export default __webpack_public_path__ + "static/media/phone.0ec4e663.svg";